import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/software/_layout/alerts/_alerts/')({
  beforeLoad: () => {
    throw redirect({
      to: '/software/alerts/no-worker'
    });
  }
});